import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./reducers/auth.reducers";
import userReducer from "./reducers/user.reducers";
import generalReducer from "./reducers/general.reducers";
import ACTIONS from "./constants";
import projectReducer from "./reducers/projects.reducers";
import clientReducer from "./reducers/clients.reducer";
import meetingReducer from "./reducers/meetings.reducers";
import scopeReducer from "./reducers/scope.reducers";
import portfolioReducer from "./reducers/portfolios.reducer";
import programReducer from "./reducers/programs.reducer";
import budgetReducer from "./reducers/budgets.reducers";
import changeRequestReducer from "./reducers/changeRequests.reducers";
import communicationReducer from "./reducers/communications.reducers";
import allocatedResourcesReducer from "./reducers/allocatedResources.reducer";
import riskReducer from "./reducers/risks.reducers";
import shiftReducer from "./reducers/shift.reducers";
import purchaseOrdersReducer from "./reducers/purchaseOrders.reducers";
import invoiceRegistryReducer from "./reducers/invoiceRegistry.reducers";
import decisionLogReducer from "./reducers/decisionLog.reducers";
import navigationReducer from "./reducers/navigation.reducer";
import milestoneReducer from "./reducers/milestone.reducer";
import runbooksReducer from "./reducers/runbooks.reducers";
import reshuffleRequestsReducer from "./reducers/reshuffleRequests.reducers";

const appReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  general: generalReducer,
  projects: projectReducer,
  clients: clientReducer,
  meetings: meetingReducer,
  scope: scopeReducer,
  milestone: milestoneReducer,
  portfolios: portfolioReducer,
  programs: programReducer,
  budgets: budgetReducer,
  changeRequests: changeRequestReducer,
  communications: communicationReducer,
  allocatedResources: allocatedResourcesReducer,
  risks: riskReducer,
  shifts: shiftReducer,
  purchaseOrders: purchaseOrdersReducer,
  invoiceRegistry: invoiceRegistryReducer,
  decisionLog: decisionLogReducer,
  navigation: navigationReducer,
  runbooks: runbooksReducer,
  reshuffleRequests: reshuffleRequestsReducer,
});

const rootReducer = (state, action) => {
  let prevState = state;
  if (action.type === ACTIONS.AUTH_LOGOUT) prevState = undefined;

  return appReducer(prevState, action);
};

export default rootReducer;
